import { BarChart3 } from "lucide-react";

// ── Props ──────────────────────────────────────────────────────────

interface ContactActionsTabProps {
  campaignCount: number;
  messageCount: number;
  opportunityCount: number;
}

// ── Component ──────────────────────────────────────────────────────

export function ContactActionsTab({
  campaignCount,
  messageCount,
  opportunityCount,
}: ContactActionsTabProps) {
  return (
    <div className="space-y-4 p-1">
      {/* ── Engagement Summary ─────────────────────────────────── */}
      <section>
        <h3 className="text-sm font-semibold mb-2 flex items-center gap-1.5">
          <BarChart3 className="h-3.5 w-3.5" />
          Engagement Summary
        </h3>
        <div className="grid grid-cols-3 gap-3">
          <div className="text-center border rounded-md p-2">
            <div className="text-lg font-bold">{campaignCount}</div>
            <div className="text-[11px] text-muted-foreground">Campaigns</div>
          </div>
          <div className="text-center border rounded-md p-2">
            <div className="text-lg font-bold">{messageCount}</div>
            <div className="text-[11px] text-muted-foreground">Messages</div>
          </div>
          <div className="text-center border rounded-md p-2">
            <div className="text-lg font-bold">{opportunityCount}</div>
            <div className="text-[11px] text-muted-foreground">Opportunities</div>
          </div>
        </div>
      </section>

      <p className="text-xs text-muted-foreground text-center pt-2">
        Contact details have moved to the Profile tab. Use the Campaigns tab to view outreach history.
      </p>
    </div>
  );
}
